"use strict";

import './layout-shared';
import '../../Content/layout/style.scss';

import { inlineSvgModule, triggerAnimations } from './layout-animations';
import { accountMenuToggle, clearAdminDropDowns, showCompanySelector, companySelectionLinkClicked, showLocationSelector, locationSelectionLinkClicked } from './layout-account-menu';
import { saveScrollPosition, loadScrollPosition } from './layout-scroll-position';
import { sidebarToggle, toggleParentMenu } from './layout-sidebar';
import { setupModalBackgroundWidthHandling } from './layout-modal-fix';

import tippy from 'tippy.js';

declare type EventFunction = () => void;
declare type EventWithParamsFunction = (this: HTMLElement, e: Event) => void;

document.addEventListener('DOMContentLoaded', function () {

    inlineSvgModule.loadAllSprites();
    triggerAnimations();

    const adminSidebarInner = document.querySelector('.admin-sidebar_inner');
    if (adminSidebarInner) {
        let lastWidth = $('#body-content').width();
        adminSidebarInner.addEventListener('transitionend', function() {
            const newWidth = $('#body-content').width();
            if (newWidth != lastWidth) {
                lastWidth = newWidth;
                window.dispatchEvent(new Event('resize'));
            }
        });
    }

    createClickEvents('.admin-sidebar_menu_item--parent > .admin-sidebar_menu_link', toggleParentMenu);
    createClickEvents('.admin-sidebar_menu_link', saveScrollPosition);

    createClickEvent('.admin-header_btn--sidebar', function () { sidebarToggle(false) });
    createClickEvent('.admin-sidebar', function () { sidebarToggle(true) });

    createClickEvent('#AccountMenuEditCompany', stopPropagation);
    createClickEvents('.company-selection-link', companySelectionLinkClicked)
    createClickEvents('.location-selection-link', locationSelectionLinkClicked)
    createClickEvent('.admin-header_btn--dropdown', accountMenuToggle);
    createClickEvent('.admin-header_dropdown_list', stopPropagation);
    window.addEventListener('click', clearAdminDropDowns);

    createClickEvent('#company-selector', showCompanySelector);
    createClickEvent('#location-selector', showLocationSelector);


    configureTooltips()

    loadScrollPosition();

    setupModalBackgroundWidthHandling();

    addEnableOldDashboardLink();
});

function createClickEvent(selector: string, event: EventFunction | EventWithParamsFunction) {
    const selected = document.querySelector(selector);
    if (selected) {
        selected.addEventListener('click', event);
    }
}

function createClickEvents(selector: string, event: EventFunction | EventWithParamsFunction) {
    document.querySelectorAll(selector)
        .forEach(selected => selected.addEventListener('click', event));
}

function stopPropagation(this: HTMLElement, e: Event) {
    e.stopPropagation();
}

function configureTooltips() {
    tippy('.tooltip-tippy', {
        content(reference) {
            const title = reference.getAttribute('title');
            reference.removeAttribute('title');
            return title;
        },
        delay: 400,
        hideOnClick: false,
        offset: [-18, 15],
        placement: 'right-start',
        theme: 'material'
    });
}

function addEnableOldDashboardLink() {
    createClickEvent('#enable-old-dashboard', function () { 
        $.ajax({
            type: "POST",
            url: siteRoot + "User/ChangeDashboardUiVersion",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify({version: 'V1'}),
            success: function (data) {
                if (data) {
                    window.location.reload();
                }
            }
        });
    });
}
